export const GET_IOS_APP_RATING = 'GET_IOS_APP_RATING';
export const GET_IOS_APP_RATING_SUCCESS = 'GET_IOS_APP_RATING_SUCCESS';
export const GET_IOS_APP_RATING_FAILED = 'GET_IOS_APP_RATING_FAILED';
export const GET_ANDROID_APP_RATING = 'GET_ANDROID_APP_RATING';
export const GET_ANDROID_APP_RATING_SUCCESS = 'GET_ANDROID_APP_RATING_SUCCESS';
export const GET_ANDROID_APP_RATING_FAILED = 'GET_ANDROID_APP_RATING_FAILED';